import { ContactExtData } from "../interfaces/DTO/crm/contact";

const isEmpty = (value: unknown) => value === null || value === undefined || value === "";

/**
 * Contact.data with one field of a nested object (e.g. residential_data.country_of_birth) set.
 *
 * - The whole data is returned: a partial update replaces the contact's data column as is, so sending only the
 *   nested object would wipe the rest of it (family_data, beneficiaries, ...).
 * - Only what is filled in is kept: an emptied field is removed (not saved as null), and so is a nested object
 *   left with nothing in it.
 */
export const withNestedDataField = (
  data: ContactExtData | undefined,
  objectKey: string,
  fieldKey: string,
  value: unknown
): ContactExtData => {
  const next: Record<string, unknown> = { ...(data ?? {}) };
  const nested: Record<string, unknown> = Object.fromEntries(
    Object.entries((next[objectKey] as Record<string, unknown> | undefined) ?? {}).filter(([, v]) => !isEmpty(v))
  );
  if (isEmpty(value)) delete nested[fieldKey];
  else nested[fieldKey] = value;

  if (Object.keys(nested).length === 0) delete next[objectKey];
  else next[objectKey] = nested;
  return next as ContactExtData;
};

/** Contact.data with a direct field set - removed when emptied */
export const withDataField = (data: ContactExtData | undefined, fieldKey: string, value: unknown): ContactExtData => {
  const next: Record<string, unknown> = { ...(data ?? {}) };
  if (isEmpty(value)) delete next[fieldKey];
  else next[fieldKey] = value;
  return next as ContactExtData;
};
